import React from 'react';

const Fill = ({ ...attrs }) => (
  <svg viewBox="0 0 64 32" {...attrs} width="1.8em">
    <g id="g18" transform="translate(0,-16.0125)">
      <path
        style={{
          fill: 'none',
          stroke: 'currentColor',
          strokeWidth: 1,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 10
        }}
        d="m 5.9,41.5 6.2,-18.4 h 2.6 L 21,41.5 H 18.5 L 16.8,35.9 H 10.1 L 8.3,41.5 Z M 11.5,31.2 10.6,34 h 5.5 l -0.9,-2.8 c -0.3,-1 -0.7,-2 -1,-3.1 -0.3,-1 -0.6,-2.1 -0.9,-3.1 h -0.1 c -0.3,1.1 -0.6,2.1 -0.9,3.1 -0.1,1.1 -0.5,2.1 -0.8,3.1 z"
        id="path12"
      />
      <path
        style={{
          fill: 'none',
          stroke: 'currentColor',
          strokeWidth: 1,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 10
        }}
        d="m 52.5,41.5 c -1.2,0 -2.2,-0.2 -3.2,-0.6 -1,-0.4 -1.8,-1.1 -2.5,-1.9 -0.7,-0.8 -1.3,-1.8 -1.7,-3 -0.4,-1.2 -0.6,-2.5 -0.6,-4 0,-1.5 0.2,-2.8 0.6,-4 0.4,-1.2 1,-2.2 1.7,-3 0.7,-0.8 1.6,-1.5 2.6,-1.9 1,-0.4 2.1,-0.7 3.2,-0.7 1.1,0 2.1,0.2 3,0.7 0.8,0.5 1.5,1 2.1,1.6 l -1.3,1.5 c -0.5,-0.5 -1,-0.9 -1.7,-1.3 -0.6,-0.3 -1.3,-0.5 -2.1,-0.5 -0.9,0 -1.7,0.2 -2.4,0.5 -0.7,0.3 -1.3,0.8 -1.8,1.5 -0.5,0.6 -0.9,1.4 -1.2,2.3 -0.3,0.9 -0.4,1.9 -0.4,3.1 0,1.2 0.1,2.2 0.4,3.1 0.3,0.9 0.6,1.7 1.1,2.4 0.5,0.7 1.1,1.2 1.8,1.5 0.7,0.4 1.5,0.5 2.4,0.5 0.9,0 1.7,-0.2 2.4,-0.5 0.7,-0.4 1.3,-0.9 1.9,-1.5 l 1.3,1.5 c -0.7,0.8 -1.5,1.5 -2.5,2 -0.9,0.5 -1.9,0.7 -3.1,0.7 z"
        id="path14"
      />
      <line
        style={{
          fill: 'none',
          stroke: 'currentColor',
          strokeWidth: 1.25,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 10
        }}
        x1="24.6"
        y1="41.5"
        x2="41.099998"
        y2="41.5"
        id="line16"
      />
    </g>
  </svg>
);

export default Fill;
